import { DAYS_TO_MS } from '@utils/constants';

function isNotificationConsideredRecent(notification) {
  if (!notification) {
    return false;
  }
  return Date.now() - notification.createdAt.getTime() < 365 * DAYS_TO_MS;
}

export { isNotificationConsideredRecent };
//# sourceMappingURL=util.is-considered-recent.js.map
